<template>
  <v-icon :size="size" data-testid="insect-locomotion-icon">
    {{ icon }}
  </v-icon>
</template>

<script>
import { LOCOMOTION_CRAWLING } from '@/libs/insectTypes';

export default {
  name: 'insect-locomotion-icon',
  props: {
    size: [Number, String],
    locomotion: String,
  },
  computed: {
    icon() {
      return this.locomotion === LOCOMOTION_CRAWLING ? 'mdi-bug-outline' : 'mdi-bee';
    },
  },
};
</script>
